import { AuthMethodSelector } from "@/components/auth/AuthMethodSelector";

const EntryPage = () => {
  return <AuthMethodSelector />;
};

export default EntryPage;

